export default __webpack_public_path__ + "static/media/cancel.b8fdc54f.svg";